import {takeEvery} from 'redux-saga/effects'

import {
  ADD_HOMEWORK,
  ADD_HOMEWORK_FEEDBACK,
  ADD_HOMEWORK_RESOURCE,
  ADD_MANY_HOMEWORK,
  ADD_TO_REPORTCARD_LABELWISE,
  ASSIGN_MARKS_TO_ALL_HOMEWORKS,
  ASSIGN_TOP_HOMEWORKS,
  CONFIRM_FILE_UPLOAD,
  DELETE_HOMEWORK,
  DELETE_HOMEWORK_FEEDBACK,
  DELETE_HOMEWORK_FILE,
  DELETE_HOMEWORK_RESOURCE,
  DELETE_MANY_HOMEWORK,
  FETCH_TERM_FROM_SETTINGS,
  GET_ALL_HOMEWORK,
  GET_HOMEWORK,
  GET_HOMEWORKS,
  GET_HOMEWORKS_MESSAGES,
  GET_HOMEWORK_DETAIL,
  GET_HOMEWORK_FEEDBACK,
  GET_HOMEWORK_REPORTS,
  GET_HOMEWORK_RESOURCES,
  GET_HOMEWORK_RESULTS,
  GET_SIGNED_UPLOAD_URL,
  GET_STUDENT_HOMEWORKS,
  GRADEWISE_HOMEWORK_LIMIT,
  MULTI_CREATE_LABEL_SETTINGS,
  PUBLISH_MANY_HOMEWORK,
  SEND_HOMEWORK_MESSAGE,
  SEND_HOMEWORK_NOTIFICATION,
  SEND_HOMEWORK_SMS,
  SUBMIT_HOMEWORK,
  TEACHER_CREATE_PERMISSION_HW,
  UPDATE_HOMEWORK,
  UPDATE_HOMEWORK_RESULT,
  VIEW_HOMEWORK_SUBMISSION,
} from '../../Actions/Homework/ActionTypes/ApiActionTypes'
import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_HOMEWORKS, fetchData)
  yield takeEvery(GET_HOMEWORK_DETAIL, fetchData)
  yield takeEvery(GET_HOMEWORKS_MESSAGES, fetchData)
  yield takeEvery(SEND_HOMEWORK_MESSAGE, fetchData)
  yield takeEvery(GET_SIGNED_UPLOAD_URL, fetchData)
  yield takeEvery(CONFIRM_FILE_UPLOAD, fetchData)
  yield takeEvery(DELETE_HOMEWORK_FILE, fetchData)
  yield takeEvery(SUBMIT_HOMEWORK, fetchData)
  yield takeEvery(GET_ALL_HOMEWORK, fetchData)
  yield takeEvery(GET_HOMEWORK, fetchData)
  yield takeEvery(ADD_HOMEWORK, fetchData)
  yield takeEvery(GET_HOMEWORK_RESOURCES, fetchData)
  yield takeEvery(ADD_HOMEWORK_RESOURCE, fetchData)
  yield takeEvery(DELETE_HOMEWORK, fetchData)
  yield takeEvery(DELETE_HOMEWORK_RESOURCE, fetchData)
  yield takeEvery(UPDATE_HOMEWORK, fetchData)
  yield takeEvery(DELETE_MANY_HOMEWORK, fetchData)
  yield takeEvery(PUBLISH_MANY_HOMEWORK, fetchData)
  yield takeEvery(ADD_MANY_HOMEWORK, fetchData)
  yield takeEvery(GET_HOMEWORK_RESULTS, fetchData)
  yield takeEvery(GET_HOMEWORK_REPORTS, fetchData)
  yield takeEvery(UPDATE_HOMEWORK_RESULT, fetchData)
  yield takeEvery(VIEW_HOMEWORK_SUBMISSION, fetchData)
  yield takeEvery(GET_HOMEWORK_FEEDBACK, fetchData)
  yield takeEvery(ADD_HOMEWORK_FEEDBACK, fetchData)
  yield takeEvery(DELETE_HOMEWORK_FEEDBACK, fetchData)
  yield takeEvery(ASSIGN_MARKS_TO_ALL_HOMEWORKS, fetchData)
  yield takeEvery(ASSIGN_TOP_HOMEWORKS, fetchData)
  yield takeEvery(GRADEWISE_HOMEWORK_LIMIT, fetchData)
  yield takeEvery(SEND_HOMEWORK_NOTIFICATION, fetchData)
  yield takeEvery(SEND_HOMEWORK_SMS, fetchData)
  yield takeEvery(TEACHER_CREATE_PERMISSION_HW, fetchData)
  yield takeEvery(ADD_TO_REPORTCARD_LABELWISE, fetchData)
  yield takeEvery(FETCH_TERM_FROM_SETTINGS, fetchData)
  yield takeEvery(MULTI_CREATE_LABEL_SETTINGS, fetchData)
  yield takeEvery(GET_STUDENT_HOMEWORKS, fetchData)
}

export default dataSaga
